/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {InjectionToken} from '@angular/core';

/**
 * This token is used to inject the object whose value should be set into `MatInput`. If none is
 * provided, the native `HTMLInputElement` is used. Directives like `MatDatepickerInput` can provide
 * themselves for this token, in order to make `MatInput` delegate the getting and setting of the
 * value to them.
 */
export const MAT_INPUT_VALUE_ACCESSOR = new InjectionToken<{value: any}>(
  'MAT_INPUT_VALUE_ACCESSOR',
);



// WEBPACK FOOTER //
// ../../../../../src/material/input/input-value-accessor.ts